export const SUBMISSION_STATUS_INITIAL_STATUS = 'INITIAL_STATUS'; 
export const SUBMISSION_STATUS_SETTING = 'SETTING'; 
export const SUBMISSION_STATUS_SUBMITTED = 'SUBMITTED'; 
export const SUBMISSION_STATUS_SUCCESS = 'SUCCESS'; 
export const SUBMISSION_STATUS_FAILED = 'FAILED'; 
